// ─── Cart.js ──────────────────────────────────────────────────────────────────
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Trash2, ShoppingBag } from 'lucide-react';
import { useCart } from '../context/AppContext';
export default function Cart() {
  const { cart, removeFromCart, updateQty, cartSubtotal } = useCart();
  const navigate = useNavigate();
  if (cart.length === 0) return (
    <div style={{ textAlign: 'center', padding: '100px 24px' }}>
      <ShoppingBag size={56} color="var(--border)" style={{ margin: '0 auto 16px' }} />
      <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 32, fontWeight: 300, marginBottom: 8 }}>Your cart is empty</h2>
      <p style={{ color: 'var(--text-light)', marginBottom: 28 }}>Discover our beautiful collections</p>
      <button className="btn btn-primary btn-lg" onClick={() => navigate('/collections')}>Browse Collections</button>
    </div>
  );
  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: '48px 24px' }} className="page-enter">
      <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 40, fontWeight: 300, marginBottom: 32 }}>Shopping Cart</h1>
      {cart.map(item => (
        <div key={item._id} style={{ display: 'flex', gap: 20, padding: '20px 0', borderBottom: '1px solid var(--border)', alignItems: 'center' }}>
          <div
  onClick={() => navigate(`/product/${item._id}`)}
  style={{
    width: 88,
    height: 88,
    borderRadius: 4,
    overflow: 'hidden',
    background: 'var(--cream)',
    flexShrink: 0,
    cursor: 'pointer'
  }}
>
            {item.images?.[0]?.url
              ? <img src={item.images[0].url} alt={item.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              : <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 32 }}>💍</div>
            }
          </div>
          <div
  style={{ flex: 1, cursor: 'pointer' }}
  onClick={() => navigate(`/product/${item._id}`)}
>
            <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 18, fontWeight: 500, marginBottom: 4 }}>{item.name}</div>
            <div style={{ fontSize: 12, color: 'var(--text-light)', marginBottom: 10, textTransform: 'capitalize' }}>{item.category}</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <button onClick={() => updateQty(item._id, item.qty - 1)} style={{ width: 28, height: 28, border: '1px solid var(--border)', background: 'white', borderRadius: 2, cursor: 'pointer', fontSize: 16 }}>−</button>
              <span style={{ fontSize: 14, minWidth: 24, textAlign: 'center' }}>{item.qty}</span>
              <button onClick={() => updateQty(item._id, item.qty + 1)} style={{ width: 28, height: 28, border: '1px solid var(--border)', background: 'white', borderRadius: 2, cursor: 'pointer', fontSize: 16 }}>+</button>
            </div>
          </div>
          <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 20, fontWeight: 400, color: 'var(--maroon)' }}>
            ₹{((item.discountPrice || item.price) * item.qty).toLocaleString()}
          </div>
          <button onClick={() => removeFromCart(item._id)} style={{ background: 'none', border: 'none', color: 'var(--text-light)', cursor: 'pointer', padding: 8 }}>
            <Trash2 size={16} />
          </button>
        </div>
      ))}
      <div style={{ background: 'var(--cream)', border: '1px solid var(--border)', borderRadius: 4, padding: 24, marginTop: 32 }}>
        {[['Subtotal', `₹${cartSubtotal.toLocaleString()}`], ['', ''], ['Total', `₹${cartSubtotal.toLocaleString()}`]].map(([l, v], i) => (
          <div key={l} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: i < 2 ? '1px solid var(--border)' : 'none', fontSize: i === 2 ? 18 : 14, fontWeight: i === 2 ? 500 : 400, color: i === 2 ? 'var(--maroon)' : 'inherit' }}>
            <span>{l}</span><span style={{ color: v === 'Free' ? 'green' : 'inherit' }}>{v}</span>
          </div>
        ))}
      </div>
      <div style={{ display: 'flex', gap: 12, marginTop: 20 }}>
        <button className="btn btn-primary btn-lg" style={{ flex: 2 }} onClick={() => navigate('/checkout')}>Proceed to Checkout</button>
        <button className="btn btn-outline btn-lg" onClick={() => navigate('/collections')}>Continue Shopping</button>
      </div>
    </div>
  );
}
